class LoadModel {
  constructor(data = {}) {
    this.idCarga = data.idCarga || 0;
    this.noCarga = data.noCarga || "";
    this.idTractocamion = data.idTractocamion || 0;
    this.numeroEconomico = data.numeroEconomico || "";
    this.idUbicacion = data.idUbicacion || 0;
    this.ubicacion = data.ubicacion || "";
    this.idTipoCarga = data.idTipoCarga || 0;
    this.idCliente = data.idCliente || 0;
    this.cliente = data.cliente || "";
    this.estatus = data.estatus || false;
    this.fechaSolicitud = data.fechaSolicitud || null;
    this.idUsuarioRegistro = data.idUsuarioRegistro || "";
    this.observaciones = data.observaciones || "";
    this.unidades = data.unidades || [];
  }
}

export { LoadModel };
